import useNativeListener from './useNativeListener';

interface Props {
    callbackFn?: () => void;
    deps?: any[];
}

function useOnBackButtonPressed({ callbackFn, deps }: Props) {
    useNativeListener('onBackButtonClick', () => {
        callbackFn?.();
    }, deps);
}

export default useOnBackButtonPressed;
